import * as types from './constants';

// Detect Tracking Carrier
export const detectTrackingCarrierRequest = data => (
  { type: types.DETECT_TRACKING_CARRIER_REQUEST, payload: data }
);

export const detectTrackingCarrierDone = data => (
  { type: types.DETECT_TRACKING_CARRIER_DONE, payload: data }
);

export const detectTrackingCarrierFailed = errors => (
  { type: types.DETECT_TRACKING_CARRIER_FAILED, payload: errors }
);

export const detectTrackingCarrierReset = () => (
  { type: types.DETECT_TRACKING_CARRIER_RESET }
);
